export default __webpack_public_path__ + "static/1652-e2d626114c9c8c8da1461e96a6ca7ed7.jpeg";